import classNames from 'classnames';
import * as PropTypes from 'prop-types';
import React from 'react';

import Tooltip from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import ModalAnchor from 'ui-library/ModalAnchor';

import SetValidationModal from './SetValidationModal';
import {validatableInputsToReadable} from './ValidatableInput';
import {VALIDATABLE_INPUT_SHAPE, ValidatableInput} from './ValidationConstants';

interface Props {
  className?: string;
  disabled?: boolean;
  modalWarningMessage?: string | null;
  size?: ButtonSize;
  validatableInputs: Array<ValidatableInput>;
}

interface State {
  isModalOpen: boolean;
}

export default class SetValidationButton extends React.Component<Props, State> {
  static propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool.isRequired,
    modalWarningMessage: PropTypes.string,
    size: PropTypes.oneOf(Object.values(ButtonSize)).isRequired,
    validatableInputs: PropTypes.arrayOf(VALIDATABLE_INPUT_SHAPE.isRequired).isRequired,
  };

  static defaultProps = {
    disabled: false,
    size: ButtonSize.MINI,
  };

  override state: State = {
    isModalOpen: false,
  };

  _handleOpenModal = (): void => {
    this.setState({isModalOpen: true});
  };

  _handleCloseModal = (): void => {
    this.setState({isModalOpen: false});
  };

  override render(): JSX.Element {
    const noInputs = this.props.validatableInputs.length === 0;
    return (
      <div className={classNames(this.props.className, 'u-display-inline-block')}>
        <ModalAnchor open={this.state.isModalOpen}>
          <SetValidationModal
            onRequestClose={this._handleCloseModal}
            validatableInputs={this.props.validatableInputs}
            warningMessage={this.props.modalWarningMessage || null}
          />
        </ModalAnchor>
        <Tooltip
          title={
            noInputs
              ? 'Set validation'
              : `Set validation on ${validatableInputsToReadable(this.props.validatableInputs, false)}`
          }
        >
          <Button
            buttonStyle={ButtonStyle.TERTIARY_GRAY}
            disabled={this.props.disabled || noInputs}
            icon="validation"
            size={this.props.size}
            onClick={this._handleOpenModal}
            dataTestAttrs={{component: 'SetValidationButton', element: 'validationButton'}}
          />
        </Tooltip>
      </div>
    );
  }
}
